import {
  CUSTOMER_UPDATE_FILTER,
  CUSTOMER_CARE_SUCCESS,
  CUSTOMER_COUNT_ASSIGN_SUCCESS,
  CUSTOMER_HISTORY_LIST_SUCCESS,
  CUSTOMER_IMPORT_SUCCESS,
  CUSTOMER_LIST_SUCCESS,
  CUSTOMER_NEW_CARE_SUCCESS,
  CUSTOMER_SAVE_SUCCESS,
} from 'src/actions/customer.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    phone: '',
    status: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  temp_customers: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const customerReducer = (state = initState, action) => {
  switch (action.type) {
    case CUSTOMER_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case CUSTOMER_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case CUSTOMER_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case CUSTOMER_CARE_SUCCESS: {
      return {
        ...state,
        newCare: undefined,
      }
    }
    case CUSTOMER_IMPORT_SUCCESS: {
      return {
        ...state,
        temp_customers: action.data,
      }
    }
    case CUSTOMER_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case CUSTOMER_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case CUSTOMER_SAVE_SUCCESS: {
      return {
        ...state,
        temp_customers: []
      }
    }
    default: {
      return state;
    }
  }
}
export default customerReducer